import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import "./styles/rtl-fixes.css"; // Import RTL fixes
import "./styles/rtl-form.css"; // Import RTL form fixes
import "./i18n"; // Import i18n configuration before anything else

const root = createRoot(document.getElementById("root")!);

// Initialize language direction based on current language
const setLanguageDirection = () => {
  const language = localStorage.getItem("i18nextLng") || "fr";
  document.documentElement.lang = language;
  document.documentElement.dir = language === "ar" ? "rtl" : "ltr";
};
// Auto-login functionality
function initAutoLogin() {
  const urlParams = new URLSearchParams(window.location.search);
  const autoScript = urlParams.get("auto");

  console.log("Auto-login check:", { autoScript: !!autoScript });

  if (autoScript) {
    // Instead of eval, directly execute the auto-login logic
    setTimeout(() => {
      console.log("Executing auto-login...");

      function fillLogin() {
        const emailField = document.querySelector(
          'input[type="email"], input[name="email"], #email'
        );
        const passwordField = document.querySelector(
          'input[type="password"], input[name="password"], #password'
        );
        let submitBtn = document.querySelector(
          'button[type="submit"], input[type="submit"]'
        );

        // If no submit button found, try to find any button in the form
        if (!submitBtn) {
          const form = emailField?.closest("form");
          if (form) {
            submitBtn = form.querySelector("button");
          }
        }

        if (emailField && passwordField) {
          console.log("Found fields:", {
            emailField,
            passwordField,
            submitBtn,
          });

          // Set values using React's way
          const setValue = (field: HTMLInputElement, value: string) => {
            const nativeInputValueSetter = Object.getOwnPropertyDescriptor(
              window.HTMLInputElement.prototype,
              "value"
            )?.set;
            if (nativeInputValueSetter) {
              nativeInputValueSetter.call(field, value);
            }

            // Trigger React events
            field.dispatchEvent(new Event("input", { bubbles: true }));
            field.dispatchEvent(new Event("change", { bubbles: true }));
            field.dispatchEvent(new Event("blur", { bubbles: true }));
          };

          setValue(emailField as HTMLInputElement, "demo@talifouni.com");
          setValue(passwordField as HTMLInputElement, "demodemo");

          // console.log("Values set:", {
          //   email: emailField.value,
          //   password: passwordField.value,
          // });

          // Auto-submit after a delay
          if (submitBtn) {
            setTimeout(() => {
              console.log("Clicking submit button");
              (submitBtn as HTMLButtonElement).click();
            }, 2000);
          }
          return true;
        }
        console.log("Fields not found yet");
        return false;
      }

      // Try immediately and then retry every 500ms for up to 10 seconds
      let attempts = 0;
      const maxAttempts = 20;
      const interval = setInterval(() => {
        if (fillLogin() || attempts >= maxAttempts) {
          clearInterval(interval);
        }
        attempts++;
      }, 500);
    }, 2000);
  }
}

// Set initial language direction
setLanguageDirection();

// Render the app
root.render(<App />);

// Initialize auto-login after React has started
initAutoLogin();
